// Do not import into this file as it is used in gatsby-config.ts

export const domains = [
  'luks_ch',
  'spital_nidwalden',
  'zentralschweizer_krebsregister',
] as const;
export type Domain = typeof domains[number];

let _domain: Domain;
export function getDomain(): Domain {
  if (typeof _domain !== 'undefined') {
    return _domain;
  }
  const domain = process.env.GATSBY_GRAPHQL_ENDPOINT?.split('/')[2];
  if (!isDomain(domain)) {
    throw new Error(`Unknown domain: "${domain}".`);
  }
  _domain = domain;
  return domain;
}

export function isDomain(domain?: string): domain is Domain {
  return domains.includes(domain as Domain);
}

export function getDomainBaseUrl(domain?: Domain): string {
  if (!domain) {
    domain = getDomain();
  }
  switch (domain) {
    case 'luks_ch':
      return 'https://www.luks.ch';
    case 'spital_nidwalden':
      return 'https://www.spital-nidwalden.ch';
    case 'zentralschweizer_krebsregister':
      return 'https://www.zentralschweizer-krebsregister.ch';
    default:
      throw new UnreachableCaseError(domain);
  }
}

export function getHiringUrl(): string {
  const domain = getDomain();
  switch (domain) {
    case 'luks_ch':
    case 'zentralschweizer_krebsregister':
      return 'https://www.luks.ch/stellen-und-karriere/offene-stellen';
    case 'spital_nidwalden':
      return 'https://www.spital-nidwalden.ch/offene-stellen';
    default:
      throw new UnreachableCaseError(domain);
  }
}

export function getCmsDomainBaseUrl(): string {
  return getDomainBaseUrl().replace('//www.', '//cms.');
}

export function getGtmId(isProdEnvironment: boolean): string {
  const domain = getDomain();
  switch (domain) {
    case 'luks_ch':
      return isProdEnvironment ? 'GTM-K6XTT93' : 'GTM-XXXXXXX-LUKS';
    case 'spital_nidwalden':
      return isProdEnvironment ? 'GTM-T5NQKDV' : 'GTM-XXXXXXX-KSNW';
    case 'zentralschweizer_krebsregister':
      return isProdEnvironment ? 'GTM-KX4CRHR' : 'GTM-XXXXXXX-ZSKR';
    default:
      throw new UnreachableCaseError(domain);
  }
}

class UnreachableCaseError extends Error {
  constructor(val: never) {
    super(`Unreachable case: ${JSON.stringify(val)}`);
  }
}

export function getOneTrustId() {
  const domain = getDomain();
  switch (domain) {
    case 'luks_ch':
      return '1fde9003-14e0-482f-ac80-9f69740429d5';
    case 'spital_nidwalden':
      return '79f18b7c-8f8a-400f-af67-acad6c045212';
    case 'zentralschweizer_krebsregister':
      return '1ea2358c-124d-4949-9bc8-354d9b62899d';
    default:
      throw new UnreachableCaseError(domain);
  }
}
